import * as Dialog from '@radix-ui/react-dialog';
import './Modal.css';

/**
 * Reusable modal wrapper built on Radix Dialog — handles portal rendering,
 * overlay, focus trapping, escape-to-close, and click-outside-to-close.
 * Replaces the 3+ hand-rolled createPortal modals in Navigation.js.
 */
export default function Modal({ open, onClose, children, className = '' }) {
  return (
    <Dialog.Root open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <Dialog.Portal>
        <Dialog.Overlay className="modal-overlay" />
        <Dialog.Content className={`modal-content ${className}`}>
          <Dialog.Close asChild>
            <button type="button" className="btn modal-close" aria-label="Close">&times;</button>
          </Dialog.Close>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
}
